import type { RootState } from "@/store/app/storeTypes";
import type { FileInfo } from "@exagens/behavioral-insight-console-client";
import type { SparxsListState } from "@/store/sparxsCatalog/listSlice";

export const getEditableSparxCatalogFile = (
  state: RootState,
  fileName: string,
): FileInfo | undefined =>
  state.editor.sparxsList.data.find((f) => f.fileName === fileName);

export const selectSparxsListPersistRehydrated = (
  state: RootState,
): boolean => {
  const p = (
    state.editor.sparxsList as SparxsListState & {
      _persist?: { rehydrated?: boolean };
    }
  )._persist;
  return p == null || p.rehydrated === true;
};
